import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@icon/chevron.svg'
import _imports_1 from '@icon/close.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1a56ca66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alert" }
const _hoisted_2 = { class: "alert__content" }
const _hoisted_3 = { class: "alert__title" }
const _hoisted_4 = {
  key: 0,
  class: "alert__card__content"
}
const _hoisted_5 = {
  key: 0,
  class: "alert__title-icon"
}
const _hoisted_6 = { class: "alert__card__content-text" }
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["alert__card", [
          `alert__card-${_ctx.alert.type.toLowerCase()}`,
          _ctx.alert.timeout === 0 && `alert__card--hidden`,
          _ctx.alert.timeout === -1 && `alert__card--hidden alert__message--removed`
        ]])
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.alertIcon)
            ? (_openBlock(), _createBlock(_component_icon, {
                key: 0,
                data: _ctx.alertIcon.data,
                fill: true,
                class: "alert__title-icon",
                color: _ctx.alertIcon.color
              }, null, 8, ["data", "color"]))
            : _createCommentVNode("", true),
          (_ctx.alert.type === 'ERROR' && !_ctx.alert.contentTitle?.length)
            ? (_openBlock(), _createBlock(_component_BaseHeading, {
                key: 1,
                level: "3",
                class: "alert__error-title"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Unexpected error encountered ")
                ]),
                _: 1
              }))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.alert.contentTitle, (message, index) => {
                return (_openBlock(), _createBlock(_component_BaseHeading, {
                  key: index,
                  level: "3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(message.text), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
        ]),
        (_ctx.alert.content?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.alertIcon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.alert.type === 'ERROR')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.alert.type === 'ERROR' && _ctx.alert.hideDetails)
                        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                            key: 0,
                            size: "medium",
                            weight: "500",
                            color: "monochrome-07"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Show Details "),
                              _createVNode(_component_icon, {
                                data: _imports_0,
                                class: _normalizeClass(["alert__error-icon", { rotated: _ctx.showError }]),
                                width: "var(--icon-16)",
                                height: "var(--icon-16)",
                                color: _ctx.isDark ? 'var(--monochrome-07)' : 'var(--monochrome-06)',
                                fill: false,
                                onClick: _ctx.onToggleErrorShow
                              }, null, 8, ["class", "color", "onClick"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_Transition, { name: "error-slide" }, {
                        default: _withCtx(() => [
                          (_ctx.showError || !_ctx.alert.hideDetails)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alert.content, (message, index) => {
                                  return (_openBlock(), _createBlock(_component_BaseSubHeading, {
                                    key: index,
                                    class: "alert__error-message",
                                    size: "medium",
                                    weight: "400",
                                    color: "monochrome-07"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(message.text), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_ctx.alert.alertRespDetail)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "alert__error-button",
                                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendReport && _ctx.sendReport(...args)))
                                    }, [
                                      _createVNode(_component_BaseSubHeading, {
                                        size: "medium",
                                        weight: "500",
                                        color: "accent-03",
                                        darkColor: "accent-200"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Submit to Support ")
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.alert.content[0])
                        ? (_openBlock(), _createBlock(_component_BaseSubHeading, {
                            key: 0,
                            size: "large",
                            weight: "500",
                            class: _normalizeClass(['alert-main-text', _ctx.alert.type === 'SUCCESS' && 'success-text'])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.alert.content[0].text), 1)
                            ]),
                            _: 1
                          }, 8, ["class"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alert.content.slice(1), (message, index) => {
                        return (_openBlock(), _createBlock(_component_BaseSubHeading, {
                          key: index,
                          class: "alert-main-text",
                          weight: "400",
                          size: "medium"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(message.text), 1)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "alert__close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeAlert')))
        }, [
          _createVNode(_component_icon, {
            data: _imports_1,
            fill: false,
            width: "var(--icon-24)",
            height: "var(--icon-24)",
            color: "#81889B"
          })
        ])
      ], 2)
    ])
  ]))
}